// src/pages/MS/MSR101F1.jsx
import React from 'react';



const MSU002F1 = () => {

    return(
        <main >
            MSU002F1
        </main>
    )
}
export default MSU002F1;
